export const isDashboardMapboxEnabled = (): boolean =>
  String(process.env.REACT_APP_ENABLE_MAPBOX_DASHBOARD || '').toLowerCase() ===
  'true';

export const hasValidMapboxPublicToken = (): boolean => {
  const token = String(process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || '').trim();
  return token.startsWith('pk.');
};

/**
 * Optional URL override so UAT (Mapbox-on) can be forced to the Google Maps
 * path that production uses, without a prod deploy:
 *   /dashboard?homeMap=google
 *   /dashboard?homeMap=mapbox
 */
export const getHomeMapProviderOverride = (
  search: string = typeof window !== 'undefined' ? window.location.search : ''
): 'google' | 'mapbox' | null => {
  try {
    const value = new URLSearchParams(search).get('homeMap');
    if (value === 'google' || value === 'mapbox') return value;
  } catch {
    // Ignore malformed query strings and fall through to env defaults.
  }
  return null;
};

/**
 * Build the query string that pins the dashboard to one provider, preserving
 * every other parameter already on the URL.
 */
export const withHomeMapProviderOverride = (
  search: string,
  provider: 'google' | 'mapbox'
): string => {
  const params = new URLSearchParams(search);
  params.set('homeMap', provider);
  return `?${params.toString()}`;
};

export const shouldUseMapboxDashboard = (
  search: string = typeof window !== 'undefined' ? window.location.search : ''
): boolean => {
  const override = getHomeMapProviderOverride(search);
  if (override === 'google') return false;
  if (override === 'mapbox') return hasValidMapboxPublicToken();
  return isDashboardMapboxEnabled() && hasValidMapboxPublicToken();
};
